import { LayoutMenuItems } from "@webV2/providers/LayoutProvider/types";
import { WebRoutes } from "@webV2/defines/routes";
import { DashboardIconAnimated } from "@cmp-src/icons/TacticIcons/DashboardIconAnimated";
import { MapIconAnimated } from "@cmp-src/icons/TacticIcons/MapIconAnimated";
import { SidebarChartAnimated } from "@cmp-src/icons/TacticIcons/SidebarChartAnimated";
import { UserIconAnimated } from "@cmp-src/icons/TacticIcons/UserIconAnimated";
import { ClipboardCheckIconAnimated } from "@cmp-src/icons/TacticIcons/ClipboardCheckIconAnimated";
import { isWorkplaceRequestsEnabled } from "@/lib/featureFlags";
import { Permissions, OrganizationSettings } from "@gettactic/api";
import { ChartIconAnimated } from "@cmp-src/icons/TacticIcons/ChartIconAnimated";

const ICON_SIZE = 26;

export const DEFAULT_MAIN_MENU_ITEMS: LayoutMenuItems = [
  {
    id: "dashboard",
    title: "Dashboard",
    url: WebRoutes.dashboard,
    icon: (props: { isActive?: boolean }) => (
      <DashboardIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true
  },
  {
    id: "map",
    title: "Map",
    url: WebRoutes.map,
    icon: (props: { isActive?: boolean }) => (
      <MapIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true,
    appendFloorId: true
  },
  {
    id: "gantt",
    title: "Schedules",
    url: WebRoutes.gantt,
    icon: (props: { isActive?: boolean }) => (
      <SidebarChartAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true,
    extraOnMobile: true
  },
  {
    id: "reports",
    title: "Reports",
    url: WebRoutes.reports,
    icon: (props: { isActive?: boolean }) => (
      <ChartIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    extraOnMobile: true,
    enabled: (permissions: Permissions) => !!permissions?.settings
  },
  {
    id: "directory",
    title: "Directory",
    url: WebRoutes.directory,
    icon: (props: { isActive?: boolean }) => (
      <UserIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: true
  },
  {
    id: "workplace-requests",
    title: "Workplace Requests",
    url: WebRoutes.workplaceRequests,
    icon: (props: { isActive?: boolean }) => (
      <ClipboardCheckIconAnimated width={ICON_SIZE} height={ICON_SIZE} />
    ),
    enabled: (
      featureFlags: NonNullable<OrganizationSettings["feature_flags"]>
    ) => isWorkplaceRequestsEnabled(featureFlags.workplace_requests),
    extraOnMobile: true
  }
];
